import { IHttpApi, IModel, IModelResponse } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';
import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

const MAX_RETRY_COUNT = 3;
const RETRY_TIMEOUT = 200;

const defaultConfig: TGetAddformMetaModel = {
  apiType: 'public',
  assertStatusCodes: [200],
  method: 'GET',
  microserviceName: 'addform',
  pathApi: '/v1/get-addform-meta/',
};

export type TGetAddformMetaModel = IModel<IGetAddformMetaRequest, IGetAddformMetaResponse>;

export interface IGetAddformMetaRequest {
  /** Id региона объявления */
  regionId: number;
  /** Категория объвления */
  category: string;
  /** Объявление от собсвенника */
  isByHomeowner: boolean;
  /** Id объявления */
  offerId?: number;
}

export interface IGetAddformMetaResponseSelfEmployedSchema {
  errorMessage: string;
  inn: string;
  isEditingDisabled: boolean;
  isInnAvailable: boolean;
  message: string;
}

export interface IGetAddformMetaResponseSchema {
  descriptionRequired: boolean;
  selfEmployed: IGetAddformMetaResponseSelfEmployedSchema;
}

export interface IGetAddformMetaResponse extends IModelResponse<IGetAddformMetaResponseSchema> {
  statusCode: 200;
}

export function createModel(config: Partial<TGetAddformMetaModel>): TGetAddformMetaModel {
  return {
    ...defaultConfig,
    ...config,
  };
}

export interface IGetAddformMetaDependencies {
  logger: ILogger;
  httpApi: IHttpApi;
  cookie?: string;
}

export const getAddformMeta = async (
  dependencies: IGetAddformMetaDependencies,
  parameters: IGetAddformMetaRequest,
) => {
  const { category, isByHomeowner, regionId } = parameters;

  const isAllRequiredParametersSet = [category, isByHomeowner, regionId]
    .every((param) => typeof param !== 'undefined' && param !== null);

  if (!isAllRequiredParametersSet) {
    return {} as IGetAddformMetaResponseSchema;
  }

  const { httpApi, logger, cookie } = dependencies;

  const headers = cookie ? [['cookie', cookie] as [string, string]] : undefined;

  const requestConfig = {
    withCredentials: true,
    headers,
  };

  const fetchWithRetry = async (retryCount: number): Promise<IGetAddformMetaResponseSchema> => {
    try {
      const { response } = await httpApi.fetch(createModel({ parameters }), { requestConfig });

      return response;
    } catch (error) {
      if (error instanceof HttpBadStatusCodeError && retryCount < MAX_RETRY_COUNT) {
        await new Promise((resolve) => {
          setTimeout(resolve, RETRY_TIMEOUT);
        });

        return fetchWithRetry(retryCount + 1);
      }

      logger.error(
        error,
        {
          description: `Addform get-addform-meta rejection error.`,
          degradation: `Unstable UI degradation has occured. Some functionality has been broken.`,
          requestParameters: {
              regionId: parameters.regionId,
              category: parameters.category,
              isByHomeowner: parameters.isByHomeowner,
          },
        },
      );

      return {} as IGetAddformMetaResponseSchema;
    }
  };

  return fetchWithRetry(0);
};
